import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { HubComponent } from '../hub.component';

@Component({
    templateUrl: './manually.add.component.html',
    styleUrls: ['./manually.add.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ManuallyAddComponent extends BaseComponent implements OnInit {
    public hubName: string;
    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private parent: HubComponent) {
        super({activatedRoute});
    }

    public ngOnInit(): void {
        let {hubName} = this.allRouteParams;
        this.parent.location = 'SUBMIT EVENT OR PLACE MANUALLY';
        this.hubName = hubName;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/manually.add/manually.add.component.ts